import { render, staticRenderFns } from "./GiderInfo.vue?vue&type=template&id=9bb32608&scoped=true"
import script from "./GiderInfo.vue?vue&type=script&lang=ts"
export * from "./GiderInfo.vue?vue&type=script&lang=ts"
import style0 from "./GiderInfo.vue?vue&type=style&index=0&id=9bb32608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb32608",
  null
  
)

export default component.exports